import { useQuery } from '@tanstack/react-query';
import { discountApi } from '@/features/discounts';
import type { DiscountResponse } from '@/features/discounts';
import { useAuthStore } from '@/features/auth';

export function usePublicDiscounts(restaurantId: string | undefined) {
  const token = useAuthStore((s) => s.token);
  return useQuery<DiscountResponse[]>({
    queryKey: ['publicActiveDiscounts', restaurantId, !!token],
    queryFn: () =>
      token
        ? discountApi.getDiscounts(token, restaurantId!)
        : discountApi.getActiveDiscounts(restaurantId!),
    enabled: !!restaurantId,
    staleTime: 30_000,
  });
}
